import { routerActions } from "connected-react-router";
import Axios from "../../../axios";
import qs from 'qs';
import { Toast } from '../../../components/spinner';
import { encrypt } from '../../../redux/helper/cryptojs';
import { isEmpty } from 'lodash';
import { login, register, dummyuser, Headers } from "../../../axios/axios_config";
import { saveState, loadState, removeItems } from "../../../redux/helper/local_storage_helper";
import { saveCurrData } from "../../../views/hitmaker/actions";
import { saveBonusGame } from '../../prize_trivia/actions/prize_trivia_action';

export const UPDATE_USER = "metadata/user";
export const CURRENT_STATUS = "metadata/status";

export const updateUserDetails = user => ({
  type: UPDATE_USER,
  payload: {
    user
  }
});

export const updateCurrStatus = (status, dispatch) => {
  dispatch({
    type: CURRENT_STATUS,
    payload: status
  })
}


/**
 * This is a App redirect funtion based on the url
 * @param  {String} stype screen name
 * @param  {String} currGame current game name
 * @param  {Number} ugId user game Id
 * @param  {Function} dispatch
 */
export function appRedirect(stype, currGame, ugId, dispatch) {
  switch (stype) {
    case 'gameresult':
      if (!ugId || isNaN(ugId) || !currGame) return dispatch(routerActions.push(`/Hitmaker`));
      dispatch(routerActions.push(`/Hitmaker/entries/result/${currGame}?userGameId=${encrypt(ugId)}`));
      break;
    case 'mygames':
      dispatch(routerActions.push(`/Hitmaker/entries`));
      break;
    case 'game':
      if (!ugId || isNaN(ugId) || !currGame) return dispatch(routerActions.push(`/Hitmaker`));
      Axios.get(`/api/entries/game-status/${ugId}`, Headers())
        .then(response => {
          if (response.data?.Item) {
            const { Status, IsCurrent, IsResultPopulated } = response.data.Item;
            if (Status >= 3 && !IsCurrent && IsResultPopulated) {
              dispatch(routerActions.push(`/Hitmaker/entries/result/${currGame}?userGameId=${encrypt(ugId)}`));
            } else {
              dispatch(routerActions.push(`/Hitmaker/game/${currGame}?userGameId=${encrypt(ugId)}`));
            }
          } else {
            dispatch(routerActions.push(`/Hitmaker`));
          }
        })
        .catch(err => {
          dispatch(routerActions.push(`/Hitmaker`));
          console.log("Unable to get game status", err);
        });
      break;
    case 'choosegame':
      dispatch(routerActions.push(`/Hitmaker`));
      break;
    case 'gamewinner':
      dispatch(routerActions.push(`/Hitmaker/winners`));
      break;
    default:
      dispatch(routerActions.push(`/Hitmaker`));
      break;
  }
}
/**
 * Actual user login
 * @param  {Object} data User credentials
 * @param  {String} redirectTo Redirect url
 * @param  {Funtion} dispatch
 */
export function updateUser(data, redirectTo, dispatch) {
  Axios.post(login.url, qs.stringify(data), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: Headers()
    }
  })
    .then(response => {
      if (response.data && response.data.access_token) {
        getUserAccess(response.data, redirectTo, dispatch);
      } else {
        Toast({ timer: 3000 })
          .fire({ text: "Can't login, Try Again Later!", })
          .then(() => {
            updateCurrStatus('phoneAuth', dispatch);
          })
      }
    })
    .catch(err => {
      console.log("Unable to update user", err);
    });
};


/**
 * Login and update the dummy user details to original user
 * @param  {Object} data User credentials
 * @param  {String} redirectTo Redirect url
 * @param  {Function} dispatch
 */
export function updatePhone(data, redirectTo, dispatch) {
  Axios.post(dummyuser.updateDummy.url, data, Headers())
    .then(response => {
      if (response.data && response.data.Item?.access_token) {
        getUserAccess(response.data.Item, redirectTo, dispatch);
      } else {
        Toast({ timer: 3000 })
          .fire({ text: "Can't login, Try Again Later!", })
          .then(() => {
            updateCurrStatus('phoneAuth', dispatch);
          })
      }
    })
}

/**
 * Get the User access Then store it locally
 * Campaign Registration and Redirect
 * @param  {Object} response Autherized user details
 * @param  {String} redirectTo Redirecting url
 * @param  {Funtion} dispatch
 */
export function getUserAccess(response, redirectTo, dispatch) {
  saveState(response, 'app_user');
  sessionStorage.setItem('activeSession', 'true');
  removeItems(['bonus_count']);
  const gameData = loadState('game_data');
  const noOfAvailableEntries = parseInt(response.noOfAvailableEntries) || 0;
  const SubscriptionType = parseInt(response.SubscriptionType) || 0;
  Promise.resolve(dispatch(updateUserDetails(response))).then(() => {
    if (!isEmpty(gameData) && gameData.gameType < 3 && (noOfAvailableEntries <= 0 && SubscriptionType === 0)) {
      saveCurrData(gameData.url, { ...gameData.data, IsSubmitted: false }).then((res) => {
        saveState({ earnTickets: true }, 'game_data');
        res.data.Item && dispatch(routerActions.push(`/Hitmaker`));
      })
    } else if (!isEmpty(gameData) && gameData.gameType < 3 && (noOfAvailableEntries > 0 || SubscriptionType === 1)) {
      saveCurrData(gameData.url, gameData.data).then((res) => {
        if (res.data.Item) {
          dispatch(routerActions.push(gameData.redirectTo));
        }
      })
    } else if (!isEmpty(gameData) && gameData.gameType === 6) {
      saveBonusGame(gameData.data);
    } else if (!isEmpty(redirectTo)) {
      const { stype, campId } = redirectTo;
      if (campId) {
        registerCampaign(campId, stype)
          .then((res) => {
            if (res.data?.Item) {
              const { GameType, UserGameId } = res.data.Item;
              let currGame = parseInt(GameType) === 1 ? 'predict-chart' : (parseInt(GameType) === 2 ? 'music-match' : null);
              appRedirect(stype, currGame, UserGameId, dispatch);
            }
          })
          .catch(err => {
            console.log("Unable to update user", err);
            dispatch(routerActions.push(`/Hitmaker`));
          });
      } else {
        dispatch(routerActions.push(`/Hitmaker`));
      }
    } else {
      dispatch(routerActions.push(`/Hitmaker`));
    }
  });
}

export function signupUser(data) {
  return Axios.post(register.url, data, Headers())
}

export function registerCampaign(campId, stype) {
  return Axios.get(`api/common/register-campaign/${campId}/${stype}`, Headers())
}
